// Replay privacy belongs to the specific value, not the screen around it.
// Keep labels, navigation, charts and control interactions readable, including
// inside account, checkout, statistics and map panels.
const MASKED_TEXT_SELECTOR = [
  '[data-ph-mask]',
  '.ph-mask',
  '.suggestionsList',
  'a[href^="mailto:"]',
  'a[href^="tel:"]'
].join(', ');

// Text masking alone does not cover tooltips/accessibility attributes on the
// same value. Preserve rendering attributes so replay keeps the real layout.
export const maskReplayAttribute = (name, value, element) => {
  if (
    /^(?:title|alt|aria-label|aria-valuetext|placeholder|value|href|src|data-(?!ph-))/.test(name) &&
    element?.closest?.(MASKED_TEXT_SELECTOR)
  ) return '*'.repeat(value.length);
  return value;
};

export const SESSION_REPLAY_CONFIG = {
  maskAllInputs: true,
  maskTextClass: 'ph-mask',
  maskTextSelector: MASKED_TEXT_SELECTOR,
  maskAllElementAttributes: false,
  maskAttributeFn: maskReplayAttribute,
  // Conversations and cancellation feedback must never enter replay payloads.
  blockSelector: '[data-ph-block], .chatbot-container, .cd-chat-root',
  recordHeaders: false,
  recordBody: false,
  recordCrossOriginIframes: false,
  collectFonts: false
};
